import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
	selector: '[ellipsisText]' ,
})
export class EllipsisFinderDirective {

    constructor(public el: ElementRef, public renderer: Renderer) {}
    ngAfterViewInit(){
        if(this.el.nativeElement.scrollWidth <= this.el.nativeElement.clientWidth){
       		this.renderer.setElementClass(this.el.nativeElement, 'tooltip-block', true);
      	}
    }
}